import { useState, type FormEvent } from 'react';

import { t } from '../i18n/es.js';

export interface LoginFormProps {
  /** Returns an error message to show, or null on success. */
  onSubmit: (email: string, password: string) => Promise<string | null>;
}

export function LoginForm({ onSubmit }: LoginFormProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const message = await onSubmit(email.trim(), password);
      if (message) setError(message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form
      className="card"
      onSubmit={(event) => void handleSubmit(event)}
      aria-labelledby="login-title"
    >
      <h1 id="login-title">{t.login.title}</h1>
      <label>
        {t.login.email}
        <input
          type="email"
          name="email"
          autoComplete="username"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </label>
      <label>
        {t.login.password}
        <input
          type="password"
          name="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </label>
      {error ? (
        <p role="alert" className="error">
          {error}
        </p>
      ) : null}
      <button type="submit" disabled={submitting}>
        {submitting ? t.login.submitting : t.login.submit}
      </button>
    </form>
  );
}
